import { useMemo } from "react";
import { bereinigtesHtml } from "./beschreibungHtml";

/** Beschreibung einer Aufgabe in der Detailansicht (bereinigtes HTML, siehe beschreibungHtml.ts). */
export function BeschreibungAnzeige({ beschreibung }: { beschreibung: string }) {
  const html = useMemo(() => bereinigtesHtml(beschreibung), [beschreibung]);
  return (
    <div
      className={
        // Kein Typografie-Plugin im Projekt: Auszeichnung hier direkt gestalten
        "break-words text-[15px] leading-[23px] text-[#374151] dark:text-foreground " +
        "[&_a]:font-semibold [&_a]:text-[#227277] [&_a]:underline [&_p]:my-1.5 [&_p:first-child]:mt-0 " +
        "[&_ul]:my-1.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-1.5 [&_ol]:list-decimal [&_ol]:pl-5 " +
        "[&_h1]:font-bold [&_h2]:font-bold [&_h3]:font-semibold [&_blockquote]:border-l-2 [&_blockquote]:border-[#E4E9E8] [&_blockquote]:pl-3"
      }
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
